import get from 'lodash/get';

import {
  asyncActionTypeFailure,
  asyncActionTypeRequest,
  asyncActionTypeSuccess,
} from 'views/AddProduct/types';
import types from './types';

const initialState = {
  qcInspectionFilters: {
    all: {},
    thirdParty: {},
    inhouse: {},
  },
  qcInspectionAllJobs: {
    loading: false,
    data: {},
    error: '',
  },
  qcInspectionThirdPartyJobs: {
    loading: false,
    data: {},
    error: '',
  },
  qcInspectionInhouseJobs: {
    loading: false,
    data: {},
    error: '',
  },
  serviceProviders: {
    loading: false,
    data: [],
    error: '',
  },
  inspectionTypes: {
    loading: false,
    data: [],
    error: '',
  },
};

export default (state = initialState, action) => {
  const tResObj = get(action, 'response.data') || {};
  switch (action.type) {
    case types.SYNC_UPDATE_QC_INSPECTION_FILTERS: {
      return {
        ...state,
        qcInspectionFilters: {
          ...state.qcInspectionFilters,
          [action.payload.key]: {
            ...action.payload.data,
          }
        },
      };
    }
    case asyncActionTypeRequest(types.GET_QC_INSPECTION_ALL_JOBS): {
      return {
        ...state,
        qcInspectionAllJobs: {
          ...state.qcInspectionAllJobs,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(types.GET_QC_INSPECTION_ALL_JOBS): {
      return {
        ...state,
        qcInspectionAllJobs: {
          loading: false,
          data: action.payload.isMore ? {
            ...state.qcInspectionAllJobs.data,
            ...tResObj,
            list: [...state.qcInspectionAllJobs.data.list, ...tResObj.list]
          } : tResObj,
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(types.GET_QC_INSPECTION_ALL_JOBS): {
      return {
        ...state,
        qcInspectionAllJobs: {
          loading: false,
          data: {},
          error: get(action, 'error'),
        },
      };
    }
    case asyncActionTypeRequest(types.GET_QC_INSPECTION_THIRD_PARTY_JOBS): {
      return {
        ...state,
        qcInspectionThirdPartyJobs: {
          ...state.qcInspectionThirdPartyJobs,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(types.GET_QC_INSPECTION_THIRD_PARTY_JOBS): {
      return {
        ...state,
        qcInspectionThirdPartyJobs: {
          loading: false,
          data: action.payload.isMore ? {
            ...state.qcInspectionThirdPartyJobs.data,
            ...tResObj,
            list: [...state.qcInspectionThirdPartyJobs.data.list, ...tResObj.list]
          } : tResObj,
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(types.GET_QC_INSPECTION_THIRD_PARTY_JOBS): {
      return {
        ...state,
        qcInspectionThirdPartyJobs: {
          loading: false,
          data: {},
          error: get(action, 'error'),
        },
      };
    }
    case asyncActionTypeRequest(types.GET_QC_INSPECTION_INHOUSE_JOBS): {
      return {
        ...state,
        qcInspectionInhouseJobs: {
          ...state.qcInspectionInhouseJobs,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(types.GET_QC_INSPECTION_INHOUSE_JOBS): {
      return {
        ...state,
        qcInspectionInhouseJobs: {
          loading: false,
          data: action.payload.isMore ? {
            ...state.qcInspectionInhouseJobs.data,
            ...tResObj,
            list: [...state.qcInspectionInhouseJobs.data.list, ...tResObj.list]
          } : tResObj,
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(types.GET_QC_INSPECTION_INHOUSE_JOBS): {
      return {
        ...state,
        qcInspectionInhouseJobs: {
          loading: false,
          data: {},
          error: get(action, 'error'),
        },
      };
    }
    case asyncActionTypeRequest(types.GET_SERVICE_PROVIDERS): {
      return {
        ...state,
        serviceProviders: {
          ...state.serviceProviders,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(types.GET_SERVICE_PROVIDERS): {
      return {
        ...state,
        serviceProviders: {
          loading: false,
          data: get(action, 'response.data') || [],
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(types.GET_SERVICE_PROVIDERS): {
      return {
        ...state,
        serviceProviders: {
          loading: false,
          data: [],
          error: get(action, 'error'),
        },
      };
    }
    case asyncActionTypeRequest(types.GET_INSPECTION_TYPE): {
      return {
        ...state,
        inspectionTypes: {
          ...state.inspectionTypes,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(types.GET_INSPECTION_TYPE): {
      return {
        ...state,
        inspectionTypes: {
          loading: false,
          data: get(action, 'response.data') || [],
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(types.GET_INSPECTION_TYPE): {
      return {
        ...state,
        inspectionTypes: {
          loading: false,
          data: [],
          error: get(action, 'error'),
        },
      };
    }
    default:
      return state;
  }
};
